import { useDispatch, useSelector } from 'react-redux';
import { HEALTHCHECK_POLL_INTERVAL } from './utils/constants';
import { getHealthCheck, selectAuthState } from './shared/sagas/auth/authSlice';
import { useEffect, useState } from 'react';
import { Alert, AlertTitle, Link } from '@mui/material';

export default function useHealthCheck() {
  const dispatch = useDispatch();
  const { healthCheck } = useSelector(selectAuthState);
  const [isNewVersionAvailable, setIsNewVersionAvailable] = useState<boolean>(false);
  const [isInMaintenanceMode, setIsInMaintenanceMode] = useState<boolean>(false);
  const localUiVersion = process.env.REACT_APP_VERSION || 'dev';

  useEffect(() => {
    //invoke on page load
    dispatch(getHealthCheck());

    console.log(`ENV: ${process.env.NODE_ENV}\nLocal UI version: ${localUiVersion}\nHealthcheck Interval: ${HEALTHCHECK_POLL_INTERVAL}`);

    //TODO: temporarily commenting out the interval bc the ResUi has a weird issue where it keeps re-rendering.
    // const interval = setInterval(() => {
    //   //fire off every HEALTHCHECK_POLL_INTERVAL's worth
    //   dispatch(getHealthCheck());
    // }, HEALTHCHECK_POLL_INTERVAL);

    // return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (!!healthCheck?.UiVersion) {
      //compare localUiVersion value with what the API says it should be
      if (localUiVersion !== healthCheck.UiVersion) {
        //they don't match
        setIsNewVersionAvailable(true);
      } else {
        //they do match
        setIsNewVersionAvailable(false);
        // console.debug(`Local and remote UI versions match. Clearing next reload event.`);
      }
    }
    setIsInMaintenanceMode(healthCheck?.IsUiInMaintenanceMode);
  }, [healthCheck]);

  return { isNewVersionAvailable: isNewVersionAvailable, isInMaintenanceMode: isInMaintenanceMode };
}

export function HealthCheckWidget() {
  const { isNewVersionAvailable } = useHealthCheck(); //invoke heathcheck process
  return isNewVersionAvailable ? (
    <>
      <Alert severity="info">
        <AlertTitle>Update available</AlertTitle>
        There is a new version of the app available. Please refresh your browser window to get it.
        <Link
          component="button"
          variant="body2"
          onClick={() => {
            window.location.reload();
          }}
        >
          Refresh Now
        </Link>
      </Alert>
    </>
  ) : (
    <></>
  );
}
